<app-armacao>
</app-armacao>

<app-confirm></app-confirm>
<app-toast></app-toast>

<ngx-loading-bar [height]="'4px'">
</ngx-loading-bar>

<app-toast></app-toast>

<app-acompanhamento-meus></app-acompanhamento-meus>
<app-atendimento-meus></app-atendimento-meus>